import { detectDPIFromFile } from './dpi.js';

export var SUPPORTED_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export var MAX_FILE_SIZE = 20 * 1024 * 1024;

export function isSupportedType(file) {
  return SUPPORTED_TYPES.indexOf(file.type) !== -1;
}

export function isWithinSizeLimit(file) {
  return file.size <= MAX_FILE_SIZE;
}

export function checkBrowserSupport() {
  return typeof window !== 'undefined' &&
    'Worker' in window &&
    'Blob' in window &&
    'HTMLCanvasElement' in window &&
    typeof window.createImageBitmap !== 'undefined';
}

export async function loadImage(file) {
  if (!isSupportedType(file)) throw new Error('UNSUPPORTED_TYPE');
  if (!isWithinSizeLimit(file)) throw new Error('SIZE_EXCEEDED');
  var arrayBuffer = await file.arrayBuffer();
  var dpi = detectDPIFromFile(arrayBuffer, file.type);
  var blob = new Blob([arrayBuffer], { type: file.type });
  var bitmap = await createImageBitmap(blob);
  return { bitmap: bitmap, width: bitmap.width, height: bitmap.height, dpi: dpi, file: file, arrayBuffer: arrayBuffer, originalBlob: blob };
}

export function unloadImage(imageData) {
  if (imageData.bitmap) imageData.bitmap.close();
  if (imageData.objectURL) URL.revokeObjectURL(imageData.objectURL);
}
